import styled from "styled-components"
import {onePxElevation} from "@irati/ui/src/global/elevation"

const ThumbnailImage = styled.img`
  ${onePxElevation};
  height: 60px;
  width: 60px;
  border-radius: 5px;
  margin: 2px;
  margin-right: 10px;
`

export default ThumbnailImage
